import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "nabil_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [settings, setSettings] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 2600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="cookie-glass fixed bottom-0 left-0 right-0 z-[80] px-6 py-5"
          data-testid="cookie-banner"
        >
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center gap-4 justify-between">
            <div>
              <p className="text-sm">Wir verwenden Cookies für ein optimales Erlebnis.</p>
              {settings && (
                <p className="text-xs mt-2" style={{ color: "#999999" }}>
                  Notwendige Cookies sind für den Betrieb der Seite erforderlich. Optionale Cookies helfen uns, das Erlebnis zu verbessern (z.B. eingebettete Karten).
                </p>
              )}
            </div>
            <div className="flex flex-wrap items-center gap-3 shrink-0">
              <button onClick={() => accept("all")} className="btn-gold !py-2.5 !px-5 !text-xs !animate-none" data-testid="cookie-accept-all">
                Alle akzeptieren
              </button>
              <button onClick={() => accept("necessary")} className="btn-ghost !py-2.5 !px-5 !text-xs" data-testid="cookie-necessary-only">
                Nur notwendige
              </button>
              <button onClick={() => setSettings(!settings)} className="text-xs underline gold-text" data-testid="cookie-settings">
                Einstellungen
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
